import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="ruralometro-header">
      <div className="ruralometro-logo">
        <h1>Paradigma Education</h1>
      </div>
      
      <nav className="ruralometro-nav">
      </nav>
      
      <div className="reporter-logo">
        <h2>Relatório Nacional de Criptomoedas</h2>
      </div>
    </header>
  );
};

export default Header;
